const videoReferences = document.querySelectorAll('.js-video-play'),
    videosContainer = document.querySelector('.js-videos-container'),
    aspectRatio = 9 / 16;

let videoArray = [],
    videosReady = 0;

export function init () {
    // Get all the videos ready
    load();

    // Pause/Close/Hide video events
    videosContainer.addEventListener('click', closeVideos);

    window.addEventListener('keydown', function (e) {
        var keyCode = e.keyCode;

        // If this is escape or enter, close the video
        if (keyCode === 27 || keyCode === 13) {
            closeVideos();
        }
    });
}

// Asynchronously retrieve all videos we have references for on this page
function load() {
    videoReferences.forEach(el => {
        var videoId = el.dataset.videoid,
            video = document.createElement('div'),
            youtubePlayer,
            vimeoPlayer,
            clonedVideoEmbed;

        //  Add unique ID to this video element
        video.id = "video_" + videoId;

        // Save video DOM element to global videos container
        videosContainer.appendChild(video);

        if (!isNaN(parseFloat(videoId)) && isFinite(videoId)) {
            vimeoPlayer = new Vimeo.Player(video, {
                width: 1280,
                id: videoId
            });

            vimeoPlayer.ready().then(videoPlayerReady(el));
        } else {
            // YouTube player
            youtubePlayer = new YT.Player(video, {
                width: '1280',
                height: '720',
                videoId: videoId,
                events: {
                    'onReady': youtubePlayerReady
                }
            });

            youtubePlayer.trigger = el;
        }

        videoArray.push({
            videoId: videoId,
            vimeoPlayer: vimeoPlayer,
            youtubePlayer: youtubePlayer,
            otherPlayer: clonedVideoEmbed
        });
    });

    // When there are the same number of iframes in videosContainer
    // as there are videoReferences we know we can move on...
    var t = setInterval(function () {
        if (videosReady === videoReferences.length) {
            clearInterval(t);

            videosContainer.classList.add('all-videos-ready');
        }
    }, 25);
}

function youtubePlayerReady(event) {
    videoPlayerReady(event.target.trigger);
}

function videoPlayerReady(el) {
    // Add click listener to this play link
    el.addEventListener('click', playVideo);

    // Add video-ready class to this play link
    el.classList.add('video-ready');

    videosReady++;
}

// Show overlay and play video
function playVideo(e) {
    e.preventDefault();

    var videoObj = videoArray.filter(obj => {
            return obj.videoId === this.dataset.videoid;
        }),
        video = document.getElementById('video_' + this.dataset.videoid);

    // Make sure all videos are hidden to start with
    let videoIframes = videosContainer.querySelectorAll('iframe');

    [...videoIframes].forEach(el => {
        el.style.display = 'none';
    });

    // Show and fadeIn video container
    videosContainer.style.display = "block";

    setTimeout(function () {
        videosContainer.classList.add('visible');
    }, 250);

    // The vimeo video iframe will actually be a child element so grab it
    if (typeof videoObj[0].vimeoPlayer !== 'undefined') {
        video = video.querySelector('iframe');
    }

    video.style.display = 'block';

    let videoStyles = window.getComputedStyle(video, null),
        videoWidth = parseInt(videoStyles.getPropertyValue('width'), 10);

    video.height = videoWidth * aspectRatio;

    if (typeof videoObj[0].vimeoPlayer !== 'undefined') {
        videoObj[0].vimeoPlayer.play();
    } else if (typeof videoObj[0].youtubePlayer !== 'undefined') {
        videoObj[0].youtubePlayer.playVideo();
    }
}

// Pause videos and hide page overlay
function closeVideos() {
    for (let i = 0; i < videoArray.length; i++) {
        if (typeof videoArray[i].vimeoPlayer !== 'undefined') {
            videoArray[i].vimeoPlayer.pause();
        } else if (typeof videoArray[i].youtubePlayer !== 'undefined') {
            videoArray[i].youtubePlayer.pauseVideo();
        } else {
            // As a last ditch attempt let's try and force a pause command through
            videoArray[i].otherPlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
    }

    // Fadeout overlay
    videosContainer.classList.remove('visible');

    // Set overlay to display:none after fadeout
    setTimeout(function () {
        videosContainer.style.display = "none";
    }, 500); // duration should be >= CSS transition time
}